// extracted by mini-css-extract-plugin
module.exports = {"btnWithAddon":"index_btnWithAddon_2VHoW","btnAddon":"index_btnAddon_2YDiN","btnAddonIcon":"index_btnAddonIcon_Nk2lM"};